import React from "react";

// Catches render/runtime errors in children (e.g. Spline failing to create a
// WebGL context on devices without GPU support) and shows a fallback instead.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn("Furloop: component failed to render, showing fallback.", error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }
    return this.props.children;
  }
}
